export function iphone() {
    return [
            'iPhone Simulator',
            'iPhone',
        ].includes(navigator.platform)
}